export const resolveLoginError = (result, fallbackMessage = "Unknown error occurred") => {
    if (result.code === 20004)
        return { kind: "warning" };
    if (!result.data) {
        return { kind: "message", content: result.msg || fallbackMessage };
    }
    const remaining = result.data.error_limit - result.data.account_error_count;
    if (result.code === 10017 || remaining === 0)
        return { kind: "locked" };
    if (remaining > 0 && remaining < 6)
        return { kind: "remaining", count: remaining };
    return { kind: "message", content: result.msg || fallbackMessage };
};
//# sourceMappingURL=error.js.map